import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { categoriesService } from '../../services'

// Async thunks
export const fetchCategories = createAsyncThunk(
  'categories/fetchCategories',
  async (_, { rejectWithValue }) => {
    try {
      const { data, error } = await categoriesService.getCategories()
      if (error) throw new Error(error)
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchCategoriesWithArtworkCount = createAsyncThunk(
  'categories/fetchCategoriesWithArtworkCount',
  async (_, { rejectWithValue }) => {
    try {
      const { data, error } = await categoriesService.getCategoriesWithArtworkCount()
      if (error) throw new Error(error)
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchCategoryById = createAsyncThunk(
  'categories/fetchCategoryById',
  async (categoryId, { rejectWithValue }) => {
    try {
      const { data, error } = await categoriesService.getCategoryById(categoryId)
      if (error) throw new Error(error)
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchCategoryBySlug = createAsyncThunk(
  'categories/fetchCategoryBySlug',
  async (slug, { rejectWithValue }) => {
    try {
      const { data, error } = await categoriesService.getCategoryBySlug(slug)
      if (error) throw new Error(error)
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

const initialState = {
  categories: [],
  selected_category: null,
  loading: false,
  error: null
}

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearSelectedCategory: (state) => {
      state.selected_category = null
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch categories
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false
        state.categories = action.payload
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      // Fetch categories with artwork count
      .addCase(fetchCategoriesWithArtworkCount.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCategoriesWithArtworkCount.fulfilled, (state, action) => {
        state.loading = false
        state.categories = action.payload
      })
      .addCase(fetchCategoriesWithArtworkCount.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      // Fetch category by ID
      .addCase(fetchCategoryById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCategoryById.fulfilled, (state, action) => {
        state.loading = false
        state.selected_category = action.payload
      })
      .addCase(fetchCategoryById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      // Fetch category by slug
      .addCase(fetchCategoryBySlug.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCategoryBySlug.fulfilled, (state, action) => {
        state.loading = false
        state.selected_category = action.payload
      })
      .addCase(fetchCategoryBySlug.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearError, clearSelectedCategory } = categoriesSlice.actions
export default categoriesSlice.reducer